import * as t from "io-ts";
import * as JsonResponse1 from "./JsonResponse1";

export const codec = JsonResponse1.createCodec(
    t.type({
        what_to_do: t.string,
        how_to_reply: t.string,
    }),
    t.type({}),
);

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    data: {
        what_to_do: "",
        how_to_reply: "",
    },
    meta: {},
});
